import React from 'react';

/**
 * <Badge tone="admin">Admin</Badge>
 * <Badge tone="success" pill>Active</Badge>
 * <Badge tone="custom" color="var(--accent)" bg="rgba(0,144,240,0.1)">Custom</Badge>
 *
 * tone — admin | analyst | viewer | success | warning | danger | info | muted | cyan
 *        or "custom" with color + bg + border props
 */
const PRESET = [
  'admin', 'analyst', 'viewer',
  'success', 'warning', 'danger', 'info', 'muted', 'cyan',
];

export default function Badge({
  tone = 'muted',
  color,
  bg,
  border,
  size = 'sm',
  pill = false,
  dot = false,
  className = '',
  style,
  children,
  ...rest
}) {
  const isPreset = PRESET.includes(tone);
  const classes = [
    'badge',
    isPreset ? `badge-${tone}` : '',
    size === 'lg' ? 'badge-lg' : '',
    pill ? 'rounded-pill' : '',
    className,
  ].filter(Boolean).join(' ');

  const custom = !isPreset && (color || bg) ? {
    color,
    background: bg,
    border: border || `1px solid ${color ? color + '40' : 'transparent'}`,
  } : null;

  return (
    <span
      className={classes}
      style={{ ...custom, ...style }}
      {...rest}
    >
      {dot && (
        <span
          aria-hidden
          style={{
            display: 'inline-block',
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: 'currentColor',
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
}
